import { IProdutoAutorizado } from "@/interfaces/IProdutoAutorizado";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "..";

interface ProdutoAutorizadoState {
  items: IProdutoAutorizado[];
  synced: boolean;
}

const initialState: ProdutoAutorizadoState = {
  items: [],
  synced: false,
};

const produtoAutorizadoSlice = createSlice({
  name: "PRODUTO_AUTORIZADO",
  initialState,
  reducers: {
    sync: (state, action: PayloadAction<{ items: IProdutoAutorizado[] }>) => {
      state.items = action.payload.items;
      state.synced = true;
    },
  },
});

export default produtoAutorizadoSlice.reducer;

export const getProdutoAutorizadoSynced = (state: RootState) =>
  state.produtoAutorizado.items;
